import { MdOutlineEmail } from "react-icons/md";
import { BsInstagram } from "react-icons/bs";
import { BsWhatsapp } from "react-icons/bs";

const Cdata=[
    {
        icon:<MdOutlineEmail/>,
        title:"Email ",
        text:" harshit14316@gmail.com",
        li:"mailto:harshit14316@gmail.com ",
        mess:"Send a message",
    },
    {
        icon:<BsInstagram/>,
        title:"Instagram",
        text:"_harshit._._._",
        li:"https://www.instagram.com/_harshit._._._/ ",
        mess:"Send a message",
    },
    {
        icon:<BsWhatsapp/>,
        title:"WhatsApp",
        text:"_harshit",
        li:"https://api.whatsapp.com/send?phone=7985403660",
        mess:"Send a message",

    }
]
export default Cdata;